export class FamilyDetailsCommonUseCase {
    constructor(searchUsecase) {
        this.searchUsecase = searchUsecase;
    }
    async getModifiedData(FDData, combinedState) {
        try {
            let searchData = this.searchUsecase.getSearchData(FDData, combinedState.searchState);
            return searchData;
        }
        catch (error) {
            return Object.assign(Object.assign({}, FDData), { familyDetails: Object.assign({}, FDData.familyDetails) });
        }
    }
}
export class SearchUseCase {
    findObjectsByValue(data, searchData) {
        return data.filter((item) => item.memberName.toLowerCase().includes(searchData.toLowerCase()));
    }
    getSearchData(FDData, searchData) {
        return;
    }
}
